import { useState, useEffect } from "react";
import { Row, Card, Tabs, Tab, Col } from 'react-bootstrap';
import { Globe } from 'react-bootstrap-icons';
import QuoteDetailHeader from "./QuoteDetailHeader";
import "./Quote.scss"
import QuoteDetailPaymentList from "./QuoteDetailPaymentList";
import QuoteDetailMedia from "./QuoteDetailMedia";
import TaskList from "./TaskList";
import axios from "axios";
import WebService from "../utility/WebService";
import HelperService from "../utility/HelperService";
import QuoteHeader from "../Header/QuoteHeader";
import QuoteDetailQuote from "./QuoteDetailQuote";
import stopIcon from "../../src/assets/images/stop.svg";
import QuoteDetailEquiment from "./QuoteDetailEquiment";
import QuoteDetailRecommendation from "./QuoteDetailRecommendation";
import phoneIcon from '../assets/images/phone.svg';
import mailIcon from '../assets/images/mail.svg';
import QuoteDetailAuthorizeWork from "./QuoteDetailAuthorizationWork";
import QuoteDetailTechnician from "./QuoteDetailTechnician";
import { toast } from "react-toastify";
import quoteImage from '../assets/images/OnInvoice.jpg';
import Loader from "../Loader/Loader";
import Footer from "../Footer/Footer";
import QuoteDetail from "./QuoteDetail";
import QuoteInfo from "./QuoteInfo";
import QuoteQuote from "./QuoteQuote";
import QuoteDetailEquipmentChecklist from "./QuoteDetailEquipmentChecklist";
import TermsCondition from "./TermsCondition";
import SignServiceQuoteWithOptions from "./SignServiceQuoteWithOptions";

interface PropData {
    isPayment?: boolean
    isReceipt?: boolean
}
interface MenuItems {
    menuCode?: string
    displayName?: string
}
const Quote = (props: PropData) => {
    const [isLoading, setLoading] = useState(false);
    const [quoteData, setQuoteData] = useState<any>({});
    const [menuItems, setMenuItems] = useState<MenuItems[]>([]);
    const [companyCode, setCompanyCode] = useState<any>();
    const [quoteNum, setQuoteNum] = useState<any>();
    const [techNum, setTechNum] = useState<any>();
    const [isShowQuote, setIsShowQuote] = useState(false)
    const [otherData, setOtherData] = useState<any>()
    const [id, setId] = useState<any>()
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const value = encodeURIComponent(urlParams.get('token') || "");
    const [isShowTermsModel, setShowTermsModel] = useState(false);
    const [isShowReason, setIsShowReason] = useState(false);
    const [allowToPickMultipleOptions, setAllowToPickMultipleOptions] = useState(false);
    const [quoteOptionsData, setQuoteOptionsData] = useState<any>({});
    
    const [pricing, setPricing] = useState<any>([]); //quoteData?.pricing || [];
    const[pricingHeaders, setPricingHeaders] =  useState<any>([]); //pricing.length > 0 ? Object.keys(pricing[0]) : [];
    const filteredPricingHeaders = [
    { key: "billingCode", title: "Billing Code", headerAlignment: "L" },
    { key: "itemDescription", title: "Description", headerAlignment: "L" },
    { key: "quantity", title: "Quantity", headerAlignment: "R" },
    { key: "totalPrice", title: "Total Price", headerAlignment: "R" },
    ];
    useEffect(() => {
        if (value) {
            setId(value)
            getAccessToken()
        } else {
            setId('')
        }
    }, [])

useEffect(() => {
  if (allowToPickMultipleOptions) {
    getSignServiceQuoteWithOptions(
      otherData.accessToken,
      otherData.companyCode,
      quoteNum,
      otherData.tenantUrl
    );
  }
}, [allowToPickMultipleOptions]);

    const getAccessToken = () => {
        localStorage.clear();
        setLoading(true)
        axios.get(`${WebService.getUrl()}admin/Auth/verify-sawinToken?id=${value}`)
            .then((res: any) => {
                setLoading(false)
                if (res.data.status == 'Error') {
                    toast.error(res.data.message)
                    setIsShowQuote(false)
                }
                if (res.data.accessToken) {
                    setOtherData(res.data)
                    getQuoteData(res.data.accessToken, res.data.companyCode,res.data.serviceMaster, res.data.quoteNumber, res.data.techNum, res.data.tenantUrl)
                    setQuoteNum(res.data.quoteNumber)
                    setTechNum(res.data.techNum)
                    setCompanyCode(res.data.companyCode)
                    //setIsShowReason(res.data.showInvoiceReason)
                    localStorage.setItem('token', res.data.accessToken)
                    localStorage.setItem('tenant_url', res.data.tenantUrl)
                   // alert(allowToPickMultipleOptions);
                   // if(allowToPickMultipleOptions) getSignServiceQuoteWithOptions(res.data.accessToken, res.data.companyCode, res.data.quoteNumber, res.data.tenantUrl);

                }
            })
            .catch((e) => {
                setId('')
                setIsShowQuote(false)
                setLoading(false);
            })
    };

    const getQuoteData = (token: string, code: string, serviceMaster: string, quoteNum: string, techNum: string, url: string) => {
        // 1297;1453
        const headers = {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
        };
        setLoading(true)
        const value = props.isReceipt ?
            `${url}/api/Quote/getQuotePrintInfo?CompanyCode=${code}&ServiceMaster=${serviceMaster}&QuoteNum=${quoteNum}&TechNum=${techNum}`
            :
            `${url}/api/Quote/getQuotesInfo?CompanyCode=${code}&ServiceMaster=${serviceMaster}&QuoteNum=${quoteNum}&TechNum=${techNum}`
        axios.get(value, {
            headers: headers,
        })
            .then((res: any) => {
                setLoading(false)
                if (res.data) {
                   //getMoreData(token, code, quoteNum, url)
                    setIsShowQuote(true)
                   // res.data.data.callInfo.quoteNum = quoteNum;
                    setQuoteData(res.data);
                   setAllowToPickMultipleOptions(res.data.data.allowToPickMultipleOptions)
                   setMenuItems([
                    { menuCode: 'Media', displayName: 'Media' },
                    { menuCode: 'QuoteInfo', displayName: 'QuoteInfo' },
                    { menuCode: 'QuoteDetail', displayName: 'QuoteDetail' },
                    { menuCode: 'Equipment', displayName: 'Equipment' }
                    ]);
                    setPricing(res?.data?.data?.pricing || []);
                    setPricingHeaders(res?.data?.data?.pricing.length > 0 ? Object.keys(res?.data?.data?.pricing[0]) : []);
                }
            })
            .catch((e) => {
                setLoading(false);
            });
    };

    const getMoreData = (token: string, code: string, quote: string, url: string) => {
        // 1297;1453
        const headers = {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
        };
        const value =
            // props.isReceipt ?
            //     `${url}/api/Invoice/customerReceiptInfo?CompanyCode=${code}&InvoiceNumber=${invoice}&InitialLoad=false`
            //     :
            `${url}/api/Invoice/customerInvoiceInfo?CompanyCode=${code}&InvoiceNumber=${quote}&InitialLoad=false`
        axios.get(value, {
            headers: headers,
        })
            .then((res: any) => {
                setLoading(false)
                if (res.data) {
                    setIsShowQuote(true)
                    res.data.quoteNumber = quote;
                    setQuoteData(res.data);
                }
            })
            .catch((e) => {
            });
    };

    const getSignServiceQuoteWithOptions = (token: string, code: string, quote: string, url: string) => {
        //url= "https://localhost:7226"
        // 1297;1453
        const headers = {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
        };
        const value =
           `${url}/api/QuotePricingOptions/GetDisplaySignServiceQuoteWithOptions?CompanyCode=${code}&QuoteNum=${quote}&IsSigned=false`
        axios.get(value, {
            headers: headers,
        })
            .then((res: any) => {
                setLoading(false)
                if (res.data) {
                    const optionsData= res.data?.data;
                   // optionsData.token= token;
                   // optionsData.allowToSelectMultipleQuote = true;
                    optionsData.url= url;
                    optionsData.termsAndConditionDescription = quoteData?.data?.termsAndConditionDescription;
                    optionsData.techNum= techNum;
                    setQuoteOptionsData(optionsData)
                }
            })
            .catch((e) => {
            });
    };

    const onTerms = () => {
        setLoading(true)
        const description = quoteData?.data?.termsAndConditionDescription;
        const fileUrl = quoteData?.data?.termsAndConditionFile;

        if (description) {
        //  window.open(description);
        setShowTermsModel(true)
        } else if (fileUrl) {
        window.open(fileUrl);
        }
        setLoading(false)
    }

   const onDownload = (code: string, serviceMaster: string, quote: string) => {
    setLoading(true);

    const url = `${WebService.getUrl()}api/Reports/GetServiceQuotePDF?CompanyCode=${code}&ServiceMaster=${serviceMaster}&QuoteNum=${quote}`;

    axios.get(url, {
        responseType: 'blob',
        headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
        }
    })
    .then((res) => {
        const blob = new Blob([res.data], { type: 'application/pdf' });

        // Use FileSaver.js for cross-browser support OR use this native way:
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = 'ServiceQuote.pdf'; // Forces "Save As"
        link.style.display = 'none';

        document.body.appendChild(link);
        link.click();

        // Cleanup
        window.URL.revokeObjectURL(downloadUrl);
        document.body.removeChild(link);

        setLoading(false);
    })
    .catch((e) => {
        console.error("Download failed", e);
        alert(`Quote PDF report not found.`);
        setLoading(false);
    });
};

const reloadQuoteInfo = () => {
    if (otherData?.accessToken && otherData?.companyCode && otherData?.serviceMaster && quoteNum && otherData?.techNum && otherData?.tenantUrl) {
        getQuoteData(
            otherData.accessToken,
            otherData.companyCode,
            otherData.serviceMaster,
            quoteNum,
            otherData.techNum,
            otherData.tenantUrl
        );
    }
};

    return <>
        <div>
            <Loader show={isLoading} />
            {otherData?.companyCode && <TermsCondition
                isShow={isShowTermsModel}
                isClose={() => setShowTermsModel(false)}
                data={otherData?.companyCode}
                desc={quoteData?.data?.termsAndConditionDescription}

            />}
            {<QuoteHeader data={quoteData} code={companyCode} quote={quoteNum} onTermsClick={() => onTerms()} onDownloadClick={() => onDownload(companyCode, quoteData?.data?.servMasterNum, quoteNum)} />}
            {
                isShowQuote &&
                <div className='p-2' style={{ backgroundColor: "#E0E0E0" }}>

                    {
                        <Card className="content-card card-shadow p-0 " style={{ marginBottom: 10 }}>
                            <Card.Body className="py-2 text-dark">
                                <Row className="mb-3 pt-1">
                                    {
                                        <Col md={3} >
                                            <img src={otherData?.genericLogoUrl} width="80%" height={130} style={{ objectFit: 'contain', marginLeft: '2%', padding: 0 }} />
                                        </Col>
                                    }
                                    <Col md={3}>
                                        <div className="mb-0 font-w-medium font-15">Company Info</div>
                                        {
                                            quoteData?.data.companyName && <div className="address-text">{quoteData?.data.companyName}</div>
                                        }
                                        {
                                            quoteData?.data.companyAddr1 && <div className="address-text">{quoteData?.data.companyAddr1}</div>
                                        }
                                        {
                                            quoteData?.data.companyAddr2 && <div className="address-text">{quoteData?.data.companyAddr2}</div>
                                        }
                                        {
                                            quoteData?.data.companyCity && <div className="address-text">{quoteData?.data.companyCity} {quoteData?.data.companyState && ', ' + quoteData?.data.companyState} {quoteData?.data.companyZip && ", " + quoteData?.data.companyZip}</div>
                                        }
                                        {
                                            quoteData?.data.companyPhone && <div className="address-text">
                                                <img src={phoneIcon} className="me-2" />
                                                {HelperService.getFormattedContact(quoteData?.data.companyPhone)}</div>
                                        }
                                        {
                                            quoteData?.data.compEmail && <div className="address-text">
                                                <img src={mailIcon} className="me-2" />
                                                {quoteData?.data.compEmail}</div>
                                        }
                                        {
                                            quoteData?.data.compWebAddress && <div className="address-text">
                                                <Globe className="me-2" />
                                                {quoteData?.data.compWebAddress}</div>
                                        }
                                    </Col>
                                    <Col md={3}>
                                        <div className="mb-0 font-w-medium font-15">Bill To {quoteData?.data.billToCustomerNum}
                                            {quoteData?.data.acctOnCreditHold == true && <img src={stopIcon} className="ms-2 mb-1" />}</div>
                                        {
                                            quoteData?.data.billToCustomerName && <div className="address-text">{quoteData?.data.billToCustomerName}</div>
                                        }
                                        {
                                            quoteData?.data.billToAddress1 && <div className="address-text">{quoteData?.data.billToAddress1}</div>
                                        }
                                        {
                                            quoteData?.data.billToAddress2 && <div className="address-text">{quoteData?.data.billToAddress2}</div>
                                        }
                                        {
                                            quoteData?.data.billToCity && <div className="address-text">{quoteData?.data.billToCity} {quoteData?.data.billToState && ', ' + quoteData?.data.billToState} {quoteData?.data.billToZip && ", " + quoteData?.data.billToZip}</div>
                                        }
                                        {
                                            quoteData?.data.billToPhone && <div className="address-text">
                                                <img src={phoneIcon} className="me-2" />
                                                {HelperService.getFormattedContact(quoteData?.data.billToPhone)}</div>
                                        }
                                        {
                                            quoteData?.data.billToEmail && <div className="address-text">
                                                <img src={mailIcon} className="me-2" />
                                                {quoteData?.data.billToEmail}</div>
                                        }
                                    </Col>
                                    <Col md={3}>
                                        <div className="mb-0 font-w-medium font-15">Location {quoteData?.data.servMasterNum}</div>
                                        {
                                            quoteData?.data.smName && <div className="address-text">{quoteData?.data.smName}</div>
                                        }
                                        {
                                            quoteData?.data.smAddress1 && <div className="address-text">{quoteData?.data.smAddress1}</div>
                                        }
                                        {
                                            quoteData?.data.smAddress2 && <div className="address-text">{quoteData?.data.smAddress2}</div>
                                        }
                                        {
                                            quoteData?.data.smCity && <div className="address-text">{quoteData?.data.smCity} {quoteData?.data.smState && ', ' + quoteData?.data.smState} {quoteData?.data.smZip && ", " + quoteData?.data.smZip}</div>
                                        }
                                        {
                                            quoteData?.data.smPhone && <div className="address-text">
                                                <img src={phoneIcon} className="me-2" />
                                                {HelperService.getFormattedContact(quoteData?.data.smPhone)}</div>
                                        }
                                        {
                                            quoteData?.data.smEmail && <div className="address-text">
                                                <img src={mailIcon} className="me-2" />
                                                {quoteData?.data.smEmail}</div>
                                        }
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    }
                    {
                       isShowReason &&
                        <Card className="content-card card-shadow p-0 mt-2">
                            <Card.Body className="py-2 text-dark">
                                <p className="mb-0 font-w-medium font-14">Call For Reason</p>
                                <p className="font-14 mb-0">{quoteData?.data.callInfo?.reasonForCall ? quoteData?.data.callInfo?.reasonForCall : '-'}</p>
                            </Card.Body>
                        </Card>
                    }

                    { <QuoteQuote data={quoteData?.data} companyCode={companyCode} techNum={otherData?.techNum}  onApproveSuccess={reloadQuoteInfo}/>}
                    { allowToPickMultipleOptions && !(quoteData?.data?.quoteSigned=="Y"? true:false) && <SignServiceQuoteWithOptions data={quoteOptionsData} onApproveSuccess={reloadQuoteInfo}/>}

                    {
                        quoteData && !HelperService.isEmptyObject(quoteData) &&
                        <div className="p-1 tab-style-2 invoicedetail-tabs" >
                            <Tabs defaultActiveKey={menuItems[0].menuCode} className=" mt-1">
                                {
                                 menuItems.length > 0 && menuItems.map((res: any) => {
                                    // Hide QuoteDetail tab when quoteSigned === "Y"
                                    if (allowToPickMultipleOptions && !(quoteData?.data?.quoteSigned === "Y") && res.menuCode === "QuoteDetail") 
                                        { return null; }
                                        return (
                                            <Tab eventKey={res.menuCode}  key={res.menuCode} 
                                                title={
                                                    <div className="d-flex flex-column justify-content-center align-items-center tab-name">
                                                        <label className="nav-text">{res.displayName}</label>
                                                    </div>
                                                }
                                            >
                                                {res.menuCode == 'QuoteInfo' &&<QuoteInfo data={quoteData?.data} />}
                                                {res.menuCode == 'Media' &&<QuoteDetailMedia data={quoteData?.data?.documents} />}
                                                {res.menuCode == 'QuoteDetail' && <QuoteDetailQuote header={filteredPricingHeaders} data={pricing} />}
                                                {res.menuCode == 'Equipment' && <QuoteDetailEquiment data={quoteData?.data} code={companyCode} otherData={otherData} />}
                                                {/*res.menuCode == 'QuoteDetail' &&<QuoteDetailQuote header={quoteData?.quoteDetailHeader} data={quoteData?.quoteDetail} />*/}
                                                {/*res.menuCode == 'Tasklist' && <TaskList data={quoteData} code={companyCode} token={value ?? ''} />*/}
                                                {/*res.menuCode == 'Quote' && <QuoteQuote data={quoteData} />}
                                                {/*(res.menuCode == 'Paymentinfo' || res.menuCode == 'PaymentInfo') && <QuoteDetailPaymentList data={quoteData} code={companyCode} payment={props.isPayment} />*/}
                                                {/*res.menuCode == 'Recommendations' && <QuoteDetailRecommendation data={quoteData} />*/}
                                                {/*res.menuCode == 'Technicians' && <QuoteDetailTechnician data={quoteData} />*/}
                                                {/*res.menuCode == 'AuthorizeWork' && <QuoteDetailAuthorizeWork data={quoteData} />*/}
                                                {/* <InvoiceDetailEquipmentChecklist data={quoteData} code={companyCode} token={value ?? ''}/> */}
                                            </Tab>
                                        )
                                    })
                                }
                            </Tabs>
                        </div>
                    }
                </div>
            }
            
            {
                isShowQuote == false && id == '' &&
                <div className="no-invoice-view">
                    <img src={quoteImage} height={200} width={200} />
                    <span className="no-invoice">No Quote Found!</span>
                </div>
            }
            {<Footer data={otherData?.genericFooter} />}
        </div>
    </>;
};

export default Quote;


